import React from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import USAMap from 'react-usa-map'
import {
  actions as formActions,
  Control,
  Errors,
  Form as ReduxForm
} from 'react-redux-form'
import { ReactBootstrapSlider } from 'react-bootstrap-slider'

import Form from '../../components/form/Form'
import Field from '../../components/form/Field'
import Action from '../../components/Action'
import * as actions from '../../actions/collegePreferencesActions'
import * as collegePreferencesActions from '../../actions/collegePreferencesActions'
import { InternalNumericStepper } from '../../components/NumericStepper'
import RequireSignIn from '../../components/RequireSignIn'
import { useInitDispatch, useTitleChange } from '../../util/hooks'
import { browserHistory } from '../../Routes'

function CollegePreferences(props) {
  useTitleChange(t`College Preferences`)
  useInitDispatch(collegePreferencesActions.loadPreferences())
  useInitDispatch(collegePreferencesActions.loadOptions())
  const { dispatch } = props
  const {
    collegePreferences: { result: collegePreferences = {} }
  } = props
  const {
    collegePreferences: {
      loadOptionsRequest: { result: options = {} }
    }
  } = props
  const { states: stateList = [], salaryRanges = [] } = options
  const {
    collegePreferences: {
      forms: { selectivity: selectivityForm }
    }
  } = props
  const { actMin, actMax, satMin, satMax } = selectivityForm
  const {
    sizes = [],
    settings = [],
    affiliations = [],
    awards = [],
    states = []
  } = collegePreferences
  const {
    collegePreferences: { updateRequest }
  } = props
  const prefButtons = (options, replaceFn) => {
    const prefButtonStyle = (option, value) => {
      const selected = option.value === value

      return {
        color: selected
          ? value === 1
            ? 'green'
            : selected && value === -1
            ? 'red'
            : '#000'
          : '#aaa',
        fontSize: '2em',
        padding: '.25rem',
        margin: '.5rem .25rem',
        backgroundColor: '#fffee8'
      }
    }
    const clickHandler = (opt, value) => () => {
      dispatch(
        actions.updatePreferences(
          replaceFn(
            options.map(_opt => {
              if (_opt.reference === opt.reference) {
                return { ..._opt, value }
              }

              return _opt
            })
          )
        )
      )
    }

    return options.map((opt, idx) => {
      return (
        <div key={opt.id} className={`row ${idx % 2 == 0 ? 'even' : 'odd'}`}>
          <div
            className="col-md-9 col-xs-6"
            style={{ lineHeight: '3em', paddingLeft: '35px', fontWeight: 'bold' }}>
            {opt.description}
          </div>
          <div className="col-md-3 col-xs-6">
            <button
              className={'h2-onet_strongly_dislike'}
              onClick={clickHandler(opt, -1)}
              style={prefButtonStyle(opt, -1)}>
              <span className="sr-only">{t`Dislike`}</span>
            </button>
            <button
              className={'h2-onet_unsure'}
              onClick={clickHandler(opt, 0)}
              style={prefButtonStyle(opt, 0)}>
              <span className="sr-only">{t`Unsure`}</span>
            </button>
            <button
              className={'h2-onet_strongly_like'}
              onClick={clickHandler(opt, 1)}
              style={prefButtonStyle(opt, 1)}>
              <span className="sr-only">{t`Like`}</span>
            </button>
          </div>
        </div>
      )
    })
  }
  const handleMapClick = event => {
    const stateId = event.target.dataset.name

    dispatch(
      actions.updatePreferences({
        ...collegePreferences,
        states: states.map(state => {
          if (stateId === state.reference) {
            const currentValue = state.value
            let newValue

            if (currentValue === 1) {
              newValue = -1
            } else if (currentValue === 0) {
              newValue = 1
            } else {
              newValue = 0
            }

            return { ...state, value: newValue }
          }

          return state
        })
      })
    )
  }
  const stateConfig = states.reduce((config, state) => {
    let fill = '#aaa'

    if (state.value === -1) {
      fill = '#ff0030'
    } else if (state.value === 1) {
      fill = '#93ca3b'
    }

    return {
      ...config,
      [state.reference]: { fill }
    }
  }, {})
  const numberInput = model => {
    const fullModel = `collegePreferences.forms.selectivity.${model}`

    return (
      <Control.input
        type="number"
        parser={s => Number(s)}
        model={fullModel}
        className="form-control"
        style={{ display: 'inline-block', width: '5rem', border: '1px solid #ccc' }}
        onChange={event => {
          dispatch(formActions.submit('collegePreferences.forms.selectivity'))
        }}
      />
    )
  }
  const actMinInput = numberInput('actMin')
  const actMaxInput = numberInput('actMax')
  const satMinInput = numberInput('satMin')
  const satMaxInput = numberInput('satMax')
  const validateBetween = (v1, v2, min, max) => {
    const num1 = Number(v1)
    const num2 = Number(v2)

    return (
      !Number.isNaN(num1) &&
      !Number.isNaN(num2) &&
      num1 <= num2 &&
      num1 >= min &&
      num2 <= max
    )
  }
  /*
   *<h4>{t`Degree Awarded`}</h4>
   *            <div className="container">
   *                <div className="row">
   *                    { prefButtons(awards, awards => {
   *                        return { ...collegePreferences, awards }
   *                    }) }
   *                </div>
   *            </div>
   */
  const onEndFunction = () => {
    if (props.onEndFunction) {
      props.onEndFunction()
    } else {
      browserHistory.push('/colleges/list?useCollegePreferences=true')
    }
  }
  const mapWidth = () => {
    if (props.inModal) {
      return 800
    }

    if (h2.isBreakpoint('lg')) {
      return 1100
    }

    if (h2.isBreakpoint('md')) {
      return 900
    }

    if (h2.isBreakpoint('sm')) {
      return 700
    }

    return 350
  }

  return (
    <RequireSignIn name={t`College Preferences`}>
      <div
        className={props.inModal ? 'container-fluid' : 'container'}
        id="college-preferences-container">
        <InternalNumericStepper
          stepNames={[t`Preferences`, t`Location`, t`Academics`, t`Financial`]}
          onEnd={onEndFunction}>
          <div>
            <h3 className="section-heading">{t`College Preferences`}</h3>
            <p className="instructions">{t`For each question below, please rate how you would feel about attending a school that matched that criteria.`}</p>
            <p className="row" style={{ display: 'flex' }}>
              <div
                style={{
                  display: 'inline-block',
                  margin: 'auto',
                  border: '1px solid #ccc',
                  backgroundColor: '#fafafa',
                  borderRadius: '5px',
                  padding: '10px'
                }}>
                <button
                  className={'h2-onet_strongly_dislike'}
                  style={{
                    marginLeft: '10px',
                    color: 'red',
                    fontSize: '2em',
                    padding: '.25rem',
                    margin: '.5rem .25rem',
                    float: 'left'
                  }}>
                  <span className="sr-only">{t`Dislike`}</span>
                </button>
                <div
                  style={{
                    lineHeight: '46px',
                    marginTop: '.5rem',
                    marginRight: '10px',
                    marginLeft: '10px',
                    float: 'left'
                  }}>
                  {t`I would not be happy with this`}
                </div>
                <button
                  className={'h2-onet_unsure'}
                  style={{
                    marginLeft: '10px',
                    color: '#000',
                    fontSize: '2em',
                    padding: '.25rem',
                    margin: '.5rem .25rem',
                    float: 'left'
                  }}>
                  <span className="sr-only">{t`Unsure`}</span>
                </button>
                <div
                  style={{
                    lineHeight: '46px',
                    marginTop: '.5rem',
                    marginRight: '10px',
                    marginLeft: '10px',
                    float: 'left'
                  }}>
                  {t`I have no opinion on this`}
                </div>
                <button
                  className={'h2-onet_strongly_like'}
                  style={{
                    marginLeft: '10px',
                    color: 'green',
                    fontSize: '2em',
                    padding: '.25rem',
                    margin: '.5rem .25rem',
                    float: 'left'
                  }}>
                  <span className="sr-only">{t`Like`}</span>
                </button>
                <div
                  style={{
                    lineHeight: '46px',
                    marginTop: '.5rem',
                    marginRight: '10px',
                    marginLeft: '10px',
                    float: 'left'
                  }}>
                  {t`I would be happy with this`}
                </div>
              </div>
            </p>

            <h4 className="section-heading">{t`Student Body Size`}</h4>
            <div className="container-fluid selection-wrap">
              <div className="row">
                {prefButtons(sizes, sizes => {
                  return { ...collegePreferences, sizes }
                })}
              </div>
            </div>

            <h4 className="section-heading">{t`Campus Setting `}</h4>
            <div className="container-fluid selection-wrap">
              <div className="row">
                {prefButtons(settings, settings => {
                  return { ...collegePreferences, settings }
                })}
              </div>
            </div>
            <h4 className="section-heading">{t`Type of School`}</h4>
            <div className="container-fluid selection-wrap">
              <div className="row">
                {prefButtons(affiliations, affiliations => {
                  return { ...collegePreferences, affiliations }
                })}
              </div>
            </div>
          </div>
          <div>
            <h3 className="section-heading">{t`Which states are you considering?`}</h3>
            <p className="instructions">
              {t`Now, think about where you would want to be located while attending school. For the states you like, click once and the map
                will turn green. If you dislike it, and don't want to consider it, click again and it will turn red. Click a third time to clear it and turn it back to gray,
                which will indicate you have no preference.`}
            </p>

            <div className="container-fluid">
              <USAMap
                onClick={handleMapClick}
                width={mapWidth()}
                customize={stateConfig}
              />
            </div>
          </div>
          <div>
            <ReduxForm
              model="collegePreferences.forms.selectivity"
              onSubmit={selectivity => {
                dispatch(
                  actions.updatePreferences({ ...collegePreferences, ...selectivity })
                )
              }}
              validators={{
                '': {
                  act: form => {
                    const { actMin, actMax } = form

                    return validateBetween(actMin, actMax, 0, 36)
                  },
                  sat: form => {
                    const { satMin, satMax } = form

                    return validateBetween(satMin, satMax, 400, 1600)
                  }
                }
              }}>
              <Action loading={updateRequest.loading}>
                {loading => {
                  return (
                    <div className="slider-container">
                      <h3 className="section-heading">
                        {t`Standardized Test Scores`} {loading}
                      </h3>
                      <p className="instructions">{t`Now, enter the scores you think you will receive (or have received) on either, or both, of the standardized tests below.`}</p>

                      <div style={{ paddingBottom: '3rem' }}>
                        <div
                          style={{
                            marginBottom: '1rem'
                          }}>
                          {jt`Average Composite ACT between ${actMinInput} and ${actMaxInput}`}
                        </div>
                        <ReactBootstrapSlider
                          min={0}
                          max={36}
                          step={1}
                          ticks={[0, 4, 8, 12, 16, 20, 24, 28, 32, 36]}
                          ticks_labels={[0, 4, 8, 12, 16, 20, 24, 28, 32, 36].map(
                            v => `${v}`
                          )}
                          width={'100%'}
                          value={[actMin, actMax]}
                          change={v => {
                            const [actMin, actMax] = v.target.value

                            dispatch(
                              formActions.change(
                                `collegePreferences.forms.selectivity.actMin`,
                                actMin
                              )
                            )
                            dispatch(
                              formActions.change(
                                `collegePreferences.forms.selectivity.actMax`,
                                actMax
                              )
                            )
                            dispatch(
                              formActions.submit('collegePreferences.forms.selectivity')
                            )
                          }}
                          marks={{
                            0: '0',
                            4: '4',
                            8: '8',
                            12: '12',
                            16: '16',
                            20: '20',
                            24: '24',
                            28: '28',
                            32: '32',
                            36: '36'
                          }}
                        />
                        <Errors
                          model="collegePreferences.forms.selectivity"
                          wrapper={props => (
                            <div className="alert alert-danger">{props.children}</div>
                          )}
                          show={form => !form.validity.act}
                          messages={{
                            act: t`ACT values are required and must fall between 0 and 36`
                          }}
                        />
                      </div>
                      <div style={{ paddingBottom: '3rem' }}>
                        <div
                          style={{
                            marginBottom: '1rem'
                          }}>
                          {jt`Average SAT between ${satMinInput} and ${satMaxInput}`}
                        </div>
                        <ReactBootstrapSlider
                          min={400}
                          max={1600}
                          step={25}
                          style={{ marginBottom: '3rem' }}
                          value={[satMin, satMax]}
                          change={v => {
                            const [satMin, satMax] = v.target.value

                            dispatch(
                              formActions.change(
                                `collegePreferences.forms.selectivity.satMin`,
                                satMin
                              )
                            )
                            dispatch(
                              formActions.change(
                                `collegePreferences.forms.selectivity.satMax`,
                                satMax
                              )
                            )
                            dispatch(
                              formActions.submit('collegePreferences.forms.selectivity')
                            )
                          }}
                          ticks={[400, 600, 800, 1000, 1200, 1400, 1600]}
                          ticks_labels={[400, 600, 800, 1000, 1200, 1400, 1600].map(
                            v => `${v}`
                          )}
                        />
                        <Errors
                          model="collegePreferences.forms.selectivity"
                          wrapper={props => (
                            <div className="alert alert-danger">{props.children}</div>
                          )}
                          show={form => !form.validity.sat}
                          messages={{
                            sat: t`SAT values are required and must fall between 400 and 1600`
                          }}
                        />
                      </div>
                    </div>
                  )
                }}
              </Action>
            </ReduxForm>
          </div>
          <div>
            <h3 className="section-heading">{t`Financial Information`}</h3>
            <p className="instructions">{t`Finally, if you know them, you can enter some basic financial information to help the system determine the likely costs for attending the schools you choose.`}</p>

            <Form
              model="collegePreferences.forms.financial"
              onSubmit={financial => {
                dispatch(
                  actions.updatePreferences({ ...collegePreferences, ...financial })
                )
              }}>
              {form => {
                return (
                  <div>
                    <Field
                      form={form}
                      model="collegePreferences.forms.financial.stateOfResidence"
                      label={t`The state you live in`}
                      type="select"
                      onChange={event => {
                        dispatch(
                          formActions.change(
                            `collegePreferences.forms.financial.stateOfResidence`,
                            event.target.value
                          )
                        )
                        dispatch(formActions.submit('collegePreferences.forms.financial'))
                      }}>
                      <option value="">Select One</option>
                      {stateList.map(state => {
                        return <option value={state.id}>{state.name}</option>
                      })}
                    </Field>
                    <Field
                      form={form}
                      model="collegePreferences.forms.financial.parentSalaryRange"
                      label={t`Your parents income range`}
                      type="select"
                      onChange={event => {
                        dispatch(
                          formActions.change(
                            `collegePreferences.forms.financial.parentSalaryRange`,
                            event.target.value
                          )
                        )
                        dispatch(formActions.submit('collegePreferences.forms.financial'))
                      }}>
                      <option value="">Select One</option>
                      {salaryRanges.map(range => {
                        return <option value={range.id}>{range.name}</option>
                      })}
                    </Field>
                    <Field
                      form={form}
                      model="collegePreferences.forms.financial.savings"
                      type="number"
                      label={t`The amount you and your parents have saved for school`}
                      onChange={event => {
                        dispatch(
                          formActions.change(
                            `collegePreferences.forms.financial.savings`,
                            event.target.value
                          )
                        )
                        dispatch(formActions.submit('collegePreferences.forms.financial'))
                      }}
                    />
                    <Field
                      form={form}
                      model="collegePreferences.forms.financial.cost"
                      type="number"
                      label={t`The approximate maximum total annual cost of schools you are considering`}
                      onChange={event => {
                        dispatch(
                          formActions.change(
                            `collegePreferences.forms.financial.cost`,
                            event.target.value
                          )
                        )
                        dispatch(formActions.submit('collegePreferences.forms.financial'))
                      }}
                    />
                  </div>
                )
              }}
            </Form>
          </div>
        </InternalNumericStepper>
      </div>
    </RequireSignIn>
  )
}

CollegePreferences.propTypes = {}
CollegePreferences.defaultProps = {}

export default connect(
  state => {
    const { collegePreferences } = state

    return {
      collegePreferences
    }
  },
  dispatch => {
    return { dispatch }
  }
)(CollegePreferences)
